// extracted by mini-css-extract-plugin
module.exports = {"container":"horizontalUnitCardLoader_container__1bTAr","card":"horizontalUnitCardLoader_card__31HUr","img":"horizontalUnitCardLoader_img__3sgeV","content":"horizontalUnitCardLoader_content__3cJeq","shine":"horizontalUnitCardLoader_shine__3u2b4"};
    if(module.hot) {
      // 1790670313946
      var cssReload = require("!../../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  